(function () {
    'use strict';

    var ivViewer = function () {
        return {
            restrict: 'AE',
            scope: {
                lowResUrl: '@',
                hiResUrl: '@'
            },
            link: function (scope, element, attrs) {
                var el = element[0];
                var viewer = new ImageViewer(el);
                viewer.load(scope.lowResUrl);

                // element.bind('contextmenu', function (event) {
                //     event.preventDefault();
                //     console.log(event);
                //     console.log(viewer);
                // });
            }
        }
    };

    ivViewer.$inject = [];
    angular.module('ecap.common').directive('ivViewer', ivViewer);
})();